/*
 * Created Date: 15-02-2023, 10:28:29 pm
 * Author: Peter
 * Email: phantrung696@gmail.com
 * -----
 * Last Modified: Fri Oct 20 2023
 * Modified By: Peter
 * -----
 * Copyright (c) 2023 PT CORP, Inc
 * -----
 * HISTORY:
 * Date      	By	Comments
 * ----------	---	----------------------------------------------------------
 */

import { getS3Url } from '@Core/Helpers/Url'
import { useCoreAuth } from '@Core/Provider/CoreAuthProvider'
import { CheckCircle } from '@mui/icons-material'
import { Avatar, Badge, styled } from '@mui/material'
import { orange } from '@mui/material/colors'
import clsx from 'clsx'
import React from 'react'

// import PropTypes from 'prop-types'

const SmallAvatar = styled(Avatar)(({ theme }) => ({
	width: 22,
	height: 22
	// border: `2px solid ${theme.palette.background.paper}`
}))

const stringToColor = string => {
	let hash = 0
	let i

	/* eslint-disable no-bitwise */
	for (i = 0; i < string.length; i += 1) {
		hash = string.charCodeAt(i) + ((hash << 5) - hash)
	}

	let color = '#'

	for (i = 0; i < 3; i += 1) {
		const value = (hash >> (i * 8)) & 0xff
		color += `00${value.toString(16)}`.slice(-2)
	}
	/* eslint-enable no-bitwise */

	return color
}

const CoreAvatar = ({ avatar_url, name, sx, className }) => {
	// const { user } = useCoreAuth()

	const getAvatar = () => {
		if (name) {
			return name?.charAt(0).toUpperCase()
		}
		return 'a'
	}

	return (
		<Badge
			overlap="circular"
			anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
			// badgeContent={<CheckCircle fontSize="small" color="info" />}
		>
			{avatar_url ? (
				<Avatar
					sx={{
						height: 40,
						width: 40,
						fontSize: 24,
						...sx
					}}
					className={className}
					src={getS3Url(avatar_url)}
				/>
			) : (
				<Avatar
					sx={{
						height: 40,
						width: 40,
						fontSize: 24,
						backgroundColor: stringToColor(getAvatar()),
						...sx
					}}
					className={clsx('p-1 uppercase', className)}
				>
					{getAvatar()}
				</Avatar>
			)}
		</Badge>
	)
}

// CoreAvatar.defaultProps = {}

// CoreAvatar.propTypes = {}

export default React.memo(CoreAvatar)
